import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

type LogoProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  withWordmark?: boolean;
};

export const Logo = ({ className, size = 'md', withWordmark = true }: LogoProps) => {
  const dim = size === 'sm' ? 22 : size === 'lg' ? 36 : 28;
  const text = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-lg';
  return (
    <Link
      to="/"
      className={cn('flex items-center gap-2 group', className)}
      aria-label="Visualry home"
    >
      <span
        className="grid place-items-center rounded-md bg-foreground/5 ring-1 ring-border-subtle"
        style={{ width: dim, height: dim }}
      >
        <svg
          width={Math.round(dim * 0.6)}
          height={Math.round(dim * 0.6)}
          viewBox="0 0 32 32"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M9 9h14M16 9v14M9 23l14-14"
            stroke="var(--color-accent)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {withWordmark && (
        <span className={cn('font-semibold tracking-tight text-foreground', text)}>Visualry</span>
      )}
    </Link>
  );
};
